import { DisplayFormat } from '../Models/DisplayFormat';

export function getCurrentDisplayFormat(): DisplayFormat {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 1024) {
        return DisplayFormat.Desktop
    } else if (windowWidth >= 768) {
        return DisplayFormat.Tablet
    }
    return DisplayFormat.Mobile
}

export function isPrideMonth(date: Date = new Date()): boolean {
    return date.getMonth() === 5; // June is month 5 (0-indexed)
}

export function isQAPridePreview(
    date: Date = new Date(),
    hostname: string = window.location.hostname
): boolean {
    return date.getMonth() === 4 && hostname === 'qa-sokeresultat.udir.no';
}

export function shouldShowPrideLogo(): boolean {
    return isPrideMonth() || isQAPridePreview();
}